import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEOHead = ({ 
  title, 
  description, 
  keywords = '',
  canonicalPath,
  ogImage = '/og-image.png',
  schema = null 
}) => {
  const location = useLocation();
  const baseUrl = 'https://americanprimellc.com';
  const fullTitle = title ? `${title} | American Prime LLC` : 'American Prime LLC | AI Automation Services & Business Consulting';
  const canonical = canonicalPath ? `${baseUrl}${canonicalPath}` : `${baseUrl}${location.pathname}`;
  
  useEffect(() => {
    // Update document title
    document.title = fullTitle;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || '');
    }
    
    // Update canonical
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', canonical);
    }
    
    // Update OG tags
    const ogTitleMeta = document.querySelector('meta[property="og:title"]');
    const ogDescMeta = document.querySelector('meta[property="og:description"]');
    const ogUrlMeta = document.querySelector('meta[property="og:url"]');
    
    if (ogTitleMeta) ogTitleMeta.setAttribute('content', fullTitle);
    if (ogDescMeta) ogDescMeta.setAttribute('content', description || '');
    if (ogUrlMeta) ogUrlMeta.setAttribute('content', canonical);
    
    // Update Twitter tags
    const twitterTitleMeta = document.querySelector('meta[name="twitter:title"]');
    const twitterDescMeta = document.querySelector('meta[name="twitter:description"]');
    const twitterUrlMeta = document.querySelector('meta[name="twitter:url"]');
    
    if (twitterTitleMeta) twitterTitleMeta.setAttribute('content', fullTitle);
    if (twitterDescMeta) twitterDescMeta.setAttribute('content', description || '');
    if (twitterUrlMeta) twitterUrlMeta.setAttribute('content', canonical);
    
    // Track page view in GA4
    if (window.trackPageView) {
      window.trackPageView(location.pathname, fullTitle);
    }
    
    // Add page-specific schema if provided
    if (schema) {
      let existingSchema = document.getElementById('page-schema');
      if (existingSchema) {
        existingSchema.remove();
      }
      
      const schemaScript = document.createElement('script');
      schemaScript.id = 'page-schema';
      schemaScript.type = 'application/ld+json';
      schemaScript.text = JSON.stringify(schema);
      document.head.appendChild(schemaScript);
    }
    
    return () => {
      // Cleanup page-specific schema
      const pageSchema = document.getElementById('page-schema');
      if (pageSchema) {
        pageSchema.remove();
      }
    };
  }, [fullTitle, description, canonical, location.pathname, schema]);
  
  return null;
};

export default SEOHead;
